// extracted by mini-css-extract-plugin
module.exports = {"loadGame":"LoadGame_loadGame__10ovp","loadGame_header":"LoadGame_loadGame_header__2H5Nt"};